import { render, staticRenderFns } from "./join-page-connect.vue?vue&type=template&id=7793fa11&"
import script from "./join-page-connect.vue?vue&type=script&lang=js&"
export * from "./join-page-connect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports